(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yotpo-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof yotpo === "object") {
    // setTimeout(() => {
      // console.log("== yotpo should refresh now. ==");
      // yotpo.refreshWidgets();
    // }, 3000);
  }
});

  } catch(e) { console.error(e); }
})();
})();
